<template>
  <div id="zyPage" class="zy_page">
    <Header />
    <component
      v-for="nav in navList"
      :key="nav.href"
      :is="nav.component"
      :data="nav.data"
      :name="nav.name"
      :id="nav.id"
    ></component>
  </div>
</template>

<script>
import { NAV } from '@/config';
import { isMobile } from '@/utils/utils';
import Header from './components/Header';
import Description from './components/Description';
import Introduction from './components/Introduction';
import Copyright from './components/Copyright';
import CopyrightPC from './components/CopyrightPC';
import ApplicationPC from './components/ApplicationPC';
import Application from './components/Application';
import Drama from './components/Drama';
import DramaPC from './components/DramaPC';
import News from './components/News';
import Investment from './components/Investment';
import Responsibility from './components/Responsibility';
import Label from './components/Label';

export default {
  name: 'Home',
  components: {
    Header,
    Introduction,
    Copyright,
    CopyrightPC,
    News,
    Investment,
    Responsibility,
    ApplicationPC,
    Application,
    Description,
    Drama,
    DramaPC,
    Label
  },
  data: function () {
    return {
      navList: isMobile() ? NAV.filter(nav => nav.type !== 'pc') : NAV.filter(nav => nav.type !== 'mobile'), // 导航列表
      rememberOffsetTop: 0
    };
  },
  beforeRouteLeave(to, from, next) {
    ///关键语句
    let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    this.rememberOffsetTop = top || 0;
    sessionStorage.setItem('rememberOffsetTop', this.rememberOffsetTop);
    next();
  },
  mounted() {
    setTimeout(() => {
      document.documentElement.scrollTop = Number(sessionStorage.getItem('rememberOffsetTop'));
    }, 20);
  }
};
</script>

<style lang="scss">
@media (min-width: 820px) and (max-width: 1280px) {
  html.L,html.M {
    zoom: 0.9;
  }
}

@media (min-width: 820px) and (max-width: 1160px) {
  html.L,html.M {
    zoom: 0.75;
  }
}
</style>
